module.exports = __webpack_public_path__ + "6e3e093dfa46eb4641d5e895b67f9e85.png";